import { SearchCollection } from "./faq-search-types";

/**
 * Recursively get all text nodes of an HTML element
 * @param element The element that contains text
 */
const getTokenizedTextNodes = (element: HTMLElement | null): Node[] => {
  if (element === null) {
    return [];
  }

  const textNodes = [];
  const treeWalker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);

  let currentNode = treeWalker.nextNode();

  while (currentNode) {
    textNodes.push(currentNode);
    currentNode = treeWalker.nextNode();
  }

  return textNodes;
};

/**
 * Index the accordion items in a collection
 */
export const updateSearchCollection = (): SearchCollection[] => {
  // Populate search collection
  const accordionItems =
    document.querySelectorAll<HTMLElement>(".accordion__item");
  const collection = [];

  for (const accordionItem of accordionItems) {
    const tokens = getTokenizedTextNodes(accordionItem);

    collection.push({
      id: accordionItem.id || "",
      text: accordionItem.textContent || "",
      element: accordionItem,
      tokens,
    });
  }

  return collection;
};
